import { mixins, typography } from '../styles/core/utils';

import { Input } from '../styles/components/forms.styles';
import styled from '@emotion/styled';
import { theme } from '../styles/core/theme';
import { tokens } from '../styles/core/tokens';

export const LoadingIndicator = styled.span`
   display: inline-flex;
   margin-left: ${tokens.space.xs};
`;

export const ComboboxContainer = styled.div`
   position: relative;
`;

export const InputWrapper = styled.div`
   position: relative;
   display: flex;
   align-items: center;
`;

export const ComboInput = styled(Input) <{ $hideText: boolean }>`
   padding-right: ${tokens.space.xl};
   text-overflow: ellipsis;
   ${typography.bodyS}
   color: ${({ $hideText }) => ($hideText ? 'transparent' : theme.colors.text.primary)};
   caret-color: ${({ $hideText }) => ($hideText ? theme.colors.text.primary : 'auto')};
`;

export const SelectedDisplay = styled.span`
   position: absolute;
   left: ${tokens.space.md};
   right: calc(${tokens.space.sm} + 20px + ${tokens.space.sm});
   top: 50%;
   transform: translateY(-50%);
   display: flex;
   align-items: center;
   justify-content: space-between;
   gap: ${tokens.space.sm};
   pointer-events: none;
   min-width: 0;
`;

export const SelectedDisplayLabel = styled.span`
   flex: 1;
   min-width: 0;
   ${mixins.truncate}
   color: ${theme.colors.text.primary};
   ${typography.bodyS}
`;

export const MetaText = styled.span`
   display: inline-flex;
   align-items: center;
   gap: ${tokens.space.xs};
   flex-shrink: 0;
   color: ${theme.colors.text.secondary};
   ${typography.bodyS}
`;

export const DropdownButton = styled.button`
   position: absolute;
   right: ${tokens.space.sm};
   top: 50%;
   transform: translateY(-50%);
   background: none;
   border: none;
   cursor: pointer;
   padding: ${tokens.space.xs};
   color: ${theme.colors.text.secondary};
   display: flex;
   align-items: center;
   justify-content: center;
   ${mixins.disabled}

   svg {
      width: 12px;
      height: 12px;
   }

   &:hover:not(:disabled) {
      color: ${theme.colors.text.primary};
   }
`;

export const DropdownList = styled.ul<{ $top: number; $left: number; $width: number }>`
   position: fixed;
   top: ${({ $top }) => $top}px;
   left: ${({ $left }) => $left}px;
   width: ${({ $width }) => $width}px;
   margin: ${tokens.space.xs} 0 0 0;
   padding: 0;
   list-style: none;
   ${mixins.card}
   box-shadow: ${tokens.shadow.md};
   max-height: 240px;
   overflow-y: auto;
   z-index: ${tokens.zIndex.modal + 1};
`;

export const DropdownItem = styled.li<{ $highlighted?: boolean; $hasData?: boolean }>`
   padding: ${tokens.space.sm} ${tokens.space.md};
   ${typography.bodyS}
   color: ${({ $hasData }) => ($hasData === false ? theme.colors.text.tertiary : theme.colors.text.primary)};
   background-color: ${({ $highlighted }) => ($highlighted ? theme.colors.bg.secondary : 'transparent')};
   ${mixins.hoverHighlight}
   display: flex;
   align-items: center;
   justify-content: space-between;
   gap: ${tokens.space.sm};
`;

export const DropdownItemLabel = styled.span`
   flex: 1;
   min-width: 0;
   ${mixins.truncate}
`;

export const NoResults = styled.li`
   padding: ${tokens.space.sm} ${tokens.space.md};
   ${typography.bodyS}
   color: ${theme.colors.text.tertiary};
   font-style: italic;
`;
